export default function WhyBrightSync() {
  const strengths = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Strategic Planning',
      description: 'Cross-functional coordination expertise'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Operations Management',
      description: 'Reliability-focused execution'
    },
    {
      icon: 'ri-links-line',
      title: 'Supply Chain Systems',
      description: 'Tech-enabled coordination platforms'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Structured Governance',
      description: 'SLA-style reporting and accountability'
    }
  ];

  return (
    <section id="why-brightsync" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
            <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Leadership</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-6">
            Why BrightSync
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <p className="text-lg text-[#5A6670] leading-relaxed mb-6">
              BrightSync is led by a reliability-focused operator experienced in managing cross-functional technical programs in mission-critical environments.
            </p>
            <p className="text-lg text-[#5A6670] leading-relaxed">
              Our approach combines operational expertise with technology-enabled coordination to deliver measurable improvements in response predictability and readiness accountability.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {strengths.map((strength, index) => (
              <div
                key={index}
                className="bg-[#E8F4F3] rounded-xl p-6 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 bg-[#0A5F5C]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${strength.icon} text-2xl text-[#0A5F5C]`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A2332] mb-2">
                  {strength.title}
                </h3>
                <p className="text-sm text-[#5A6670]">
                  {strength.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
